import { render } from "./GradientCard.vue?vue&type=template&id=7d99be7c&scoped=true"
import script from "./GradientCard.vue?vue&type=script&lang=js"
export * from "./GradientCard.vue?vue&type=script&lang=js"

import "./GradientCard.vue?vue&type=style&index=0&id=7d99be7c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d99be7c"]])

export default __exports__